// extracted by mini-css-extract-plugin
export default {"container":"ProjectsList_container__Rle2a"};